import React, { useEffect, useState } from 'react';
import { HourglassIcon } from 'lucide-react';
const TOTAL_SECONDS = 22 * 60 + 22;
function useCountdown(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => setSeconds(s => s > 0 ? s - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  return {
    mm: Math.floor(seconds / 60),
    ss: seconds % 60
  };
}
function Unit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <span className="inline-flex items-baseline gap-1" data-id="element-101" data-mp="k30youdzwkkr">
      <span className="font-display text-lg font-extrabold tabular-nums text-ice sm:text-xl" data-id="element-102" data-mp="5d38ya0f3mtg">
        {String(value).padStart(2, '0')}
      </span>
      <span className="text-[10px] font-semibold uppercase tracking-[0.14em] text-steel" data-id="element-103" data-mp="acxxw80mu2bv">{label}</span>
    </span>;
}
export function OfferBar() {
  const {
    mm,
    ss
  } = useCountdown(TOTAL_SECONDS);
  return <div role="region" aria-label="Offer countdown" className="fixed inset-x-0 top-0 z-50 border-b-2 border-crimson bg-charcoal text-ice shadow-[0_8px_24px_-12px_rgba(0,0,0,0.8)]" data-id="element-104" data-mp="1ayifk59n6b1">
      <div className="mx-auto flex h-11 max-w-5xl items-center justify-center gap-4 px-4 sm:gap-6" data-id="element-105" data-mp="mxgordxf9nvl">
        <p className="flex items-center gap-2 whitespace-nowrap text-[11px] font-bold uppercase tracking-[0.16em] text-ice/85 sm:text-xs" data-id="element-106" data-mp="10wq2m6y5o5we">
          <HourglassIcon className="h-4 w-4 shrink-0 text-crimson" aria-hidden="true" data-id="element-107" data-mp="88khhj36wew1" />
          Offer expires in:
        </p>
        <p className="flex shrink-0 items-baseline gap-1.5" aria-live="off" data-id="element-108" data-mp="3asglzkkhifp">
          <Unit value={mm} label="Min" data-id="element-109" data-mp="hz5ex374nddd" />
          <span className="font-display text-lg font-extrabold text-crimson" data-id="element-110" data-mp="i082b158qxoj">:</span>
          <Unit value={ss} label="Sec" data-id="element-111" data-mp="d757kpoq9i6r" />
        </p>
      </div>
    </div>;
}